import { render } from "./T3Table.vue?vue&type=template&id=45b2a9d3"
import script from "./T3Table.vue?vue&type=script&lang=js"
export * from "./T3Table.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jenna\\Desktop\\Project\\Outsource\\jy-admin2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__